import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, Chip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { TABLE_TYPES, FIXED_ELEMENT_TYPES, ZONE_TYPES, ELEMENT_COLORS } from './elementDefaults';

const DraggableItem = ({ category, subType, label, color }) => {
  const handleDragStart = (e) => {
    e.dataTransfer.setData('application/json', JSON.stringify({ category, subType }));
  };

  return (
    <Chip
      label={label}
      draggable
      aria-roledescription="draggable"
      onDragStart={handleDragStart}
      sx={{
        m: 0.5,
        cursor: 'grab',
        backgroundColor: color || '#ccc',
        color: '#fff',
        fontWeight: 600,
        fontSize: 11,
        '&:hover': { opacity: 0.85 },
        '&:active': { cursor: 'grabbing' },
      }}
    />
  );
};

const Toolbar = () => {
  return (
    <Box role="region" aria-label="Element toolbar" sx={{ width: 220, overflowY: 'auto', borderRight: '1px solid #ddd', p: 1 }}>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>
        Drag elements onto canvas
      </Typography>

      <Accordion defaultExpanded disableGutters>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2" fontWeight={600}>Tables</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ display: 'flex', flexWrap: 'wrap', p: 1 }}>
          {TABLE_TYPES.map((t) => (
            <DraggableItem
              key={t.subType}
              category="table"
              subType={t.subType}
              label={t.label}
              color={ELEMENT_COLORS[t.tableType] || ELEMENT_COLORS.table}
            />
          ))}
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded disableGutters>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2" fontWeight={600}>Fixed Elements</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ display: 'flex', flexWrap: 'wrap', p: 1 }}>
          {FIXED_ELEMENT_TYPES.map((t) => (
            <DraggableItem
              key={t.subType}
              category="fixed"
              subType={t.subType}
              label={t.label}
              color={ELEMENT_COLORS[t.subType] || '#999'}
            />
          ))}
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded disableGutters>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2" fontWeight={600}>Zones</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ display: 'flex', flexWrap: 'wrap', p: 1 }}>
          {ZONE_TYPES.map((t) => (
            <DraggableItem
              key={t.subType}
              category="zone"
              subType={t.subType}
              label={t.label}
              color={ELEMENT_COLORS[t.subType] || 'rgba(200,200,200,0.6)'}
            />
          ))}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default Toolbar;
